import { render } from "./pos-employee.vue?vue&type=template&id=522b7708"
import script from "./pos-employee.vue?vue&type=script&lang=js"
export * from "./pos-employee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__